/* src/app/shared/components/pgc-filter/pgc-filter.component.css */
:host {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.pgc-filter-container {
  display: flex;
  align-items: center;
}
.pgc-filter-toggle {
  display: flex;
  align-items: center;
}
.pgc-filter-panel {
  margin-top: 8px;
}
.pgc-filter-criteria-list {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 12px;
}
.pgc-filter-criteria-item {
  display: flex;
  align-items: center;
}
.pgc-filter-actions {
  display: flex;
  align-items: center;
}
.btn-add {
  margin-top: 27px;
}
.btn-save {
  margin-top: 28px;
}
.filter-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.keep-filter-row {
  display: flex;
  align-items: center;
}
.keep-filter-tooltip {
  margin-top: 0;
}
/*# sourceMappingURL=pgc-filter.component.css.map */
